import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfirmEventType, ConfirmationService } from 'primeng/api';
import { DataService } from 'src/app/services/data.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';


@Component({
  selector: 'app-survey-attendance',
  templateUrl: './survey-attendance.component.html',
  styleUrls: ['./survey-attendance.component.scss'],
  providers: [ConfirmationService]
})
export class SurveyAttendanceComponent {

  survey: any;
  loading: boolean = false;

  messages: any[] = [];

  constructor(
    private activatedRoute: ActivatedRoute,
    private dataService: DataService,
    private confirmationService: ConfirmationService,
    private location: Location
  ) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe(params => {
      let surveyId = params['surveyId'];
      if (surveyId) {
        this.getSurveyAttendances(surveyId);
      }
    })
  }

  goBack(): void {
    this.location.back();
  }

  async getSurveyAttendances(surveyId: string) {
    try {
      this.loading = true;
      let url = 'survey-attendance/' + surveyId;
      let res = await this.dataService.getData(url);
      this.loading = false;
      if (res.error) {
        return;
      }
      console.log(res.data);
      this.survey = res.data;
      console.log("Survey",this.survey);
    } catch (e) {
    }
  }

  getName(name: any) {
    return Object.values(name).join(' ');
  }

  async markAttendance(email: string) {
    try {
      let url = 'survey-attendance/mark';
      let data = {
        surveyId: this.survey.surveyId,
        email: email,
        markType: 'BY_PC'
      }
      let res = await this.dataService.postData(url, data);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: 'خطأ', detail: res.msg },
        ];
        return;
      }
      this.getSurveyAttendances(this.survey.surveyId);
    } catch (e) {
      this.messages = [
        { severity: 'error', summary: 'خطأ' },
      ];
    }
  }

  confirmMark(email: string) {
    this.confirmationService.confirm({
      message: this.translate('Are you sure you want to mark this attendance?'),
      header: this.translate('Mark Attendance'),
      icon: '',
      acceptLabel: 'نعم',
      rejectLabel: 'لا',
      accept: () => {
        this.markAttendance(email);
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }
  
  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }
}
